import React, { useEffect, useState } from 'react';
import { getCurrentUser } from 'aws-amplify/auth';
import {
  displayableAppDomain,
  displayableAppVersion,
  displayableUserAgent,
} from '../../services/technical_info';
import { userIsCreator } from '../../services/users';
import {
  useGetCurrentSpaceMembershipQuery,
  useGetUserProfileQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';

const AppTechnicalInfoLabel = () => {
  const { data: userProfile } = useGetUserProfileQuery();

  const isSmorgStudio = userIsCreator(userProfile);

  const { data: currentSpaceMembership } = useGetCurrentSpaceMembershipQuery(
    undefined,
    {
      skip: !userProfile || isSmorgStudio,
    },
  );

  const [userId, setUserId] = useState('');

  useEffect(() => {
    console.log('Loading user data');
    getCurrentUser().then((currentUser) => {
      setUserId(currentUser.username);
    });
  }, []);

  return (
    <div style={{ fontSize: '14px' }}>
      <strong>Version:</strong> {displayableAppVersion()}{' '}
      {displayableAppDomain()}
      <br />
      <strong>Device:</strong> {displayableUserAgent()}
      <br />
      {isSmorgStudio
        ? `userid ${userId}`
        : `smid ${currentSpaceMembership?.id}`}
    </div>
  );
};

export default AppTechnicalInfoLabel;
